import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { EUserOrderBy } from 'src/common/constants/userSortKeys';
import { filterUsers } from 'src/helpers/filterUsers';
import { EOrder } from 'src/interfaces/Order';
import { IUser } from 'src/interfaces/User';

interface Props {
  users: IUser[];
  value: IUser | null;
  onChange: (user: IUser | null) => void;
  disabled?: boolean;
  label?: string;
  placeholder?: string;
}

export default function UserAutocomplete({
  users,
  value,
  onChange,
  disabled = false,
  label,
  placeholder,
}: Props) {
  const { t } = useTranslation();
  const [query, setQuery] = useState('');

  const filteredUsers = useMemo(
    () =>
      filterUsers(users, {
        query,
        roleFilter: null,
        orderBy: EUserOrderBy.name,
        orderDir: EOrder.asc,
      }),
    [users, query],
  );

  return (
    <Autocomplete
      options={filteredUsers}
      value={value}
      onChange={(_, next) => onChange(next)}
      onInputChange={(_, next) => setQuery(next)}
      getOptionLabel={option => `${option.name} (${option.email})`}
      isOptionEqualToValue={(option, optionValue) => option.id === optionValue.id}
      disabled={disabled}
      renderInput={params => (
        <TextField
          {...params}
          label={label ?? t('users.filterLabel')}
          placeholder={placeholder ?? t('users.filterPlaceholder')}
          margin="none"
          fullWidth
        />
      )}
    />
  );
}
